import { Injectable } from '@angular/core';

import { BridgeService } from '../bridge/bridge.service';

/**
 * Generic HTTP wrapper for the /idm/v1/ui-preferences/user endpoint.
 * This service is intentionally kept generic — the payload shape is
 * opaque (Record<string, any>) so any feature can store its own key.
 *
 * For landing-page preferences the key is 'landingPage'.
 * Future features can add their own keys without changing this service.
 */
@Injectable({
    providedIn: 'root',
})
export class UiPreferencesApiService {
    constructor(private _bridge: BridgeService) {}

    /**
     * GET /idm/v1/ui-preferences/user
     * Returns the full preferences object for the current user.
     */
    getUiPreferences = (): Promise<Record<string, any> | null> => {
        return new Promise((resolve, reject) => {
            this._bridge.getUiPreferences(
                res => {
                    // Backend wraps the payload under a `response` key
                    const prefs = res?.response ?? null;
                    resolve(prefs && Object.keys(prefs).length ? prefs : null);
                },
                res => reject(res)
            );
        });
    };

    /**
     * POST /idm/v1/ui-preferences/user
     * Upserts the preferences object for the current user.
     */
    saveUiPreferences = (preferences: Record<string, any>): Promise<Record<string, any>> => {
        return new Promise((resolve, reject) => {
            this._bridge.saveUiPreferences(
                preferences,
                // Resolve with the sent preferences — they are the source of truth
                () => resolve(preferences),
                res => reject(res)
            );
        });
    };

    /**
     * DELETE /idm/v1/ui-preferences/user
     * Removes all preferences for the current user.
     */
    deleteUiPreferences = (): Promise<void> => {
        return new Promise((resolve, reject) => {
            this._bridge.deleteUiPreferences(
                () => resolve(),
                res => reject(res)
            );
        });
    };
}
